import React from "react";
import styled from "styled-components";
import { formatPrice } from "../utils/helpers";
import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const Product = ({ img, name, price, weekendPrice }) => {
  return (
    <Wrapper>
      <Link to={`/products/${name}`} className="card-link">
        <div className="image-wrap">
          <img src={img} alt={name} />
          {weekendPrice ? (
            <span className="badge">víkend od {formatPrice(weekendPrice)}</span>
          ) : null}
        </div>
        <footer>
          <div className="info">
            <h5>{name}</h5>
            <p className="price">od {formatPrice(price)}</p>
          </div>
          <span className="arrow" aria-hidden="true">
            <FaArrowRight />
          </span>
        </footer>
      </Link>
    </Wrapper>
  );
};

const Wrapper = styled.article`
  height: 100%;

  .card-link {
    display: block;
    background: var(--clr-paper);
    border-radius: var(--radius-lg);
    overflow: hidden;
    border: 1px solid var(--clr-divider);
    box-shadow: var(--shadow-sm);
    transition: transform var(--transition), box-shadow var(--transition);
    color: inherit;
    text-decoration: none;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .card-link:hover {
    transform: translateY(-4px);
    box-shadow: var(--shadow-lg);
  }
  .card-link:hover img {
    transform: scale(1.05);
  }

  .image-wrap {
    position: relative;
    aspect-ratio: 4 / 3;
    background: var(--clr-cream-warm);
    overflow: hidden;
  }
  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    transition: transform 500ms cubic-bezier(0.4, 0, 0.2, 1);
  }

  .badge {
    position: absolute;
    top: 0.75rem;
    left: 0.75rem;
    background: rgba(27, 20, 16, 0.85);
    color: var(--clr-accent-light);
    font-family: var(--ff-body);
    font-size: 0.7rem;
    font-weight: 600;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    padding: 0.3rem 0.6rem;
    border-radius: var(--radius-pill);
    backdrop-filter: blur(4px);
  }

  footer {
    padding: 1rem 1.25rem 1.25rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    flex: 1;
  }
  .info {
    flex: 1;
    min-width: 0;
  }
  footer h5 {
    color: var(--clr-charcoal-1);
    font-family: var(--ff-display);
    font-weight: 600;
    font-size: 1.05rem;
    margin: 0 0 0.25rem;
    line-height: 1.3;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: none;
    letter-spacing: 0;
  }
  .price {
    margin: 0;
    color: var(--clr-accent-dark);
    font-weight: 600;
    font-size: 0.95rem;
    letter-spacing: 0;
  }
  .arrow {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: var(--clr-cream-warm);
    color: var(--clr-accent-dark);
    transition: var(--transition);
    flex-shrink: 0;
  }
  .card-link:hover .arrow {
    background: var(--clr-accent);
    color: var(--clr-paper);
    transform: translateX(2px);
  }
`;

export default Product;
